export const colors = {
    Black: "#27373C",
    White: "#FFFFFF",


// MAIN COLORS
    WerfenColor: "#001387",
    WerfenColorMid: "#27318D",
    WerfenColorLight: "#4D55A1",
    WerfenSecondaryColor: "#2B29FF",

    WerfenColor2: "#4D55A1",
    WerfenColor3: "#8086BC",
    WerfenColor4: "#ABAFD2",
    WerfenColor5: "#DCDEED",

// SUPPORT COLORS
    WerfenFormFieldColor: "#FFFFFF",
    WerfenFormTextColor: "#001387",
    WerfenFormIconColor: "#001387",
    WerfenFormIconBackgroundColor: "#FFFFFF",

//CONSTRAST COLOR
    WerfenColorContrast: "#E86D2A",

//IL COLORS
    ILColor: "#AFBA34",
    ILColorMid: "#AABA0A",
    ILColorLight: "#C3D600",

    ILColor1: "#2BAED8",
    ILColor3: "#6EBEE0",
    ILColor4: "#9FD0E7",
    ILColor5: "#CEE7F0",

//WERFEN CONSTRAST COLOR
    ILColorContrast: "#EAAA00",

//COOL GRAY
    CoolGray: "#B1B3B3",
    CoolGray2: "#C3C0C1",
    CoolGray3: "#D2D0D0",
    CoolGray4: "#E2DFDF",
    CoolGray5: "#F1EEEF",

//DARK COLORS
    Dark: "#000b67",
    Dark2: "#91A7B2",
    Dark3: "#C5D7DB",
    Dark4: "#EBEEF7",

//FX COLORS
    Shadow: "#E5E5E5",
    SwitchColor: "#C9D6DA",
    StripedRowColor: "#EBEEF7",
    HoverRowColor: "#DCDEED",

// ADDITIONAL COLORS
    OfflineColor: "#BB4343",
    SAPBadgeColor: "#2076D2",
    IframeVideoColor: "#F44802",
    ExtLinkColor: "#08c99e",
    SuggestionHoverColor: "#4D55A1",
    SuggestionBoxEntryColor: "#7b7b7b",
    SuggestionHoverColorActive: "#27318D",
    ActiveFilterIndicatorColor: "#001387",
    CarouselItemDataColor: "#808080", // a.k.a. "gray"

// RGB GRAYS BY OPACITY PERCENTAGE
    Gray5: "rgba(0,0,0,0.05)",
    Gray12: "rgba(0,0,0,0.12)",
    Gray20: "rgba(0,0,0,0.2)",
    Gray25: "rgba(0,0,0,0.25)",
    Gray60: "rgba(0,0,0,0.6)",
}

